import { AssignmentIcon, IconSize, IconWrapper, Link, SaveFileIcon } from '@dreryk/react-components';

import { ExtendedDosage } from '~libs.shared.prescription';

import { extendedDosageTemplatesTranslationKeys } from '../../../../../translations';
import { DosageTemplatesModalOpener } from '../../../prescriptionTemplates/extendedDosage/modal/DosageTemplatesModal.opener';

import { ExtendedDosageHeaderActionsPortal } from './ExtendedDosageHeaderActionsPortal';
import { useExtendedDosageTemplateUse } from './ExtendedDosageTemplateActions.hooks';

type ExtendedDosageTemplateActionsProps = {
   readonly getTemplateExtendedDosage: () => ExtendedDosage;
   readonly applyTemplateExtendedDosage: (extendedDosage: ExtendedDosage) => void;
   readonly shouldConfirmUse: boolean;
   readonly saveTemplateDisabled: boolean;
};

export const ExtendedDosageTemplateActions = (props: ExtendedDosageTemplateActionsProps): JSX.Element => {
   const useTemplate = useExtendedDosageTemplateUse(props.applyTemplateExtendedDosage);

   return (
      <ExtendedDosageHeaderActionsPortal>
         <DosageTemplatesModalOpener
            defaultTemplate={undefined}
            onUse={useTemplate}
            shouldConfirmUse={props.shouldConfirmUse}
         >
            {({ openModal }) => (
               <Link
                  testId={'insertExtendedDosageFromTemplate'}
                  label={extendedDosageTemplatesTranslationKeys.insertFromTemplate}
                  icon={
                     <IconWrapper testId={'insertExtendedDosageFromTemplate'} size={IconSize.SMALL}>
                        <AssignmentIcon />
                     </IconWrapper>
                  }
                  onClick={openModal}
               />
            )}
         </DosageTemplatesModalOpener>
         <DosageTemplatesModalOpener
            defaultTemplate={() => ({ extendedDosage: props.getTemplateExtendedDosage() })}
            onUse={useTemplate}
            shouldConfirmUse={props.shouldConfirmUse}
         >
            {({ openModal }) => (
               <Link
                  testId={'saveExtendedDosageTemplate'}
                  label={extendedDosageTemplatesTranslationKeys.saveTemplate}
                  icon={<SaveFileIcon />}
                  disabled={props.saveTemplateDisabled}
                  onClick={openModal}
               />
            )}
         </DosageTemplatesModalOpener>
      </ExtendedDosageHeaderActionsPortal>
   );
};
